import { synapse } from 'state'
import { BASE_URL } from 'config'
import { trimStart } from 'lodash'
import prop from 'lodash/fp/prop'

const getBody = prop('body')

const getCustomUrl = (endpoint) =>
  endpoint ? `${BASE_URL}/${trimStart(endpoint, '/')}` : undefined

export const getPermissionsUrl = (wtId, documentType) =>
  `${BASE_URL}/workingtables/${wtId}/${documentType}/permissions`

export const getDocumentUrl = (documentType, activityId, id) => {
  const url = `${BASE_URL}/${documentType}`
  return activityId && id ? `${url}/activityId=${activityId}&id=${id}` : url
}

export const deleteDocumentById = (type, id) => {
  const documentURL = getDocumentUrl(type, id.activityId, id.id)
  return synapse.fetch(documentURL, { method: 'DELETE' }).then(getBody)
}

export const updateDocument = ({
  customEndpoint,
  documentType,
  activityId,
  data,
  id
}) => {
  const url =
    getCustomUrl(customEndpoint) || getDocumentUrl(documentType, activityId, id)
  return synapse.fetch(url, { method: 'PUT' }, data).then(getBody)
}

export const addDocument = ({ documentType, data, customEndpoint }) => {
  const url = getCustomUrl(customEndpoint) || getDocumentUrl(documentType)
  return synapse.fetch(url, { method: 'POST' }, data).then(getBody)
}

export const getPermissionsForDocumentType = (wtId, documentType) => {
  return synapse.fetch(getPermissionsUrl(wtId, documentType)).then(getBody)
}

export const patchDocumentFetch = ({ data, id: rowId }) => {
  const { id, activityId } = rowId
  const path = `${BASE_URL}/workingtables/${activityId}/documents/${id}`

  return synapse
    .fetch(
      path,
      {
        method: 'PATCH'
      },
      data
    )
    .then(() => ({
      patch: true,
      id: rowId
    }))
}

export const getDocumentsOfType = async (instanceId, type, requestBody) => {
  const {
    body: { metadata, items }
  } = await synapse.fetch(
    `${BASE_URL}/instances/${instanceId}/documents/${type}`,
    { method: 'POST' },
    requestBody
  )

  return {
    total: metadata.pagination.total,
    items
  }
}
